import React from "react";
import { Stack, Typography } from "@mui/material";
import AccountTreeIcon from "@mui/icons-material/AccountTree";

import { useNavigate } from "hooks";
import { useDealActions, useDealSubAssetsSelector, useParentDealSelect } from "store";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";
import { Menu } from "components/popups";
import { RoleComponentGuard } from "components/guards";
import { RoleName } from "../../constants";

export const DealHierarchy: React.FC = () => {
  const subDeals = useDealSubAssetsSelector();
  const parentDeal = useParentDealSelect();
  const navigate = useNavigate();
  const { setHierarchyPanelOpenAction } = useDealActions();

  return (
    <Stack
      sx={{
        p: "16px",
        borderRadius: 16,
        bgcolor: "white",
        boxShadow: "sm",
        flexGrow: 1,
        ul: {
          pl: "25px",
          overflow: "hidden"
        },
        li: {
          width: "auto",
          color: "#26A6AE",
          fontSize: "16px",
          fontWeight: 400,
          cursor: "pointer",
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis"
        }
      }}
    >
      <Stack direction="row" sx={{ justifyContent: "space-between", alignItems: "center" }}>
        <Typography sx={{ fontSize: "18px", fontWeight: 500, color: "#071F35" }}>
          {parentDeal ? "Parent deal" : "Sub deals"}
        </Typography>
        <RoleComponentGuard availableRoles={[RoleName.Admin, RoleName.Analyst]}>
          <Menu
            iconButtonProps={{ size: "sm" }}
            options={[
              {
                title: "Deal hierarchy",
                icon: <AccountTreeIcon />,
                onClick: () => setHierarchyPanelOpenAction(true)
              }
            ]}
          />
        </RoleComponentGuard>
      </Stack>
      <ul>
        {parentDeal ? (
          <li onClick={() => navigate({ route: "deal", params: { deal_id: parentDeal.id } })}>{parentDeal.title}</li>
        ) : (
          subDeals.map((item) => (
            <MaterialTooltip key={item.id} title={item.title}>
              <li onClick={() => navigate({ route: "deal", params: { deal_id: item.id } })}>{item.title}</li>
            </MaterialTooltip>
          ))
        )}
      </ul>
    </Stack>
  );
};
